import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home'
import Loader from '@/views/Loader'
import Game from '@/views/Game'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/histoire',
      name: 'home',
      component: Home
    },
    {
      path: '/jeu',
      name: 'game',
      component: Game
    },
    {
      path: '/',
      name: 'loader',
      component: Loader
    }
  ]
})
